export const RESET_LEAD_TITLE: string = 'Reset incorrectly reported lead';
export const RESET_LEAD_PLACEHOLDER: string = 'Enter lead id';
export const RESET_LEAD_SUBMIT_TEXT: string = 'Reset';

export const RESET_SUCCESSFULLY: string = 'Lead was successfully reset';
